export const FETCH_SITE_CARD_REQUEST = 'FETCH_SITE_CARD_REQUEST';
export const FETCH_SITE_CARD_SUCCESS = 'FETCH_SITE_CARD_SUCCESS';
export const FETCH_SITE_CARD_FAILURE = 'FETCH_SITE_CARD_FAILURE';

export const FETCH_SITE_CARD_OWNERSHIP_REQUEST = 'FETCH_SITE_CARD_OWNERSHIP_REQUEST';
export const FETCH_SITE_CARD_OWNERSHIP_SUCCESS = 'FETCH_SITE_CARD_OWNERSHIP_SUCCESS';
export const FETCH_SITE_CARD_OWNERSHIP_FAILURE = 'FETCH_SITE_CARD_OWNERSHIP_FAILURE';

export const FETCH_SITE_CARD_AREA_INFO_REQUEST = 'FETCH_SITE_CARD_AREA_INFO_REQUEST';
export const FETCH_SITE_CARD_AREA_INFO_SUCCESS = 'FETCH_SITE_CARD_AREA_INFO_SUCCESS';
export const FETCH_SITE_CARD_AREA_INFO_FAILURE = 'FETCH_SITE_CARD_AREA_INFO_FAILURE';

export const FETCH_SITE_CARD_ANALYSES_REQUEST = 'FETCH_SITE_CARD_ANALYSES_REQUEST';
export const FETCH_SITE_CARD_ANALYSES_SUCCESS = 'FETCH_SITE_CARD_ANALYSES_SUCCESS';
export const FETCH_SITE_CARD_ANALYSES_FAILURE = 'FETCH_SITE_CARD_ANALYSES_FAILURE';

export const FETCH_SITE_CARD_PLANNING_APPLICATIONS_REQUEST = 'FETCH_SITE_CARD_PLANNING_APPLICATIONS_REQUEST';
export const FETCH_SITE_CARD_PLANNING_APPLICATIONS_SUCCESS = 'FETCH_SITE_CARD_PLANNING_APPLICATIONS_SUCCESS';
export const FETCH_SITE_CARD_PLANNING_APPLICATIONS_FAILURE = 'FETCH_SITE_CARD_PLANNING_APPLICATIONS_FAILURE';

export const FETCH_SITE_CARD_VALUE_INFO_REQUEST = 'FETCH_SITE_CARD_VALUE_INFO_REQUEST';
export const FETCH_SITE_CARD_VALUE_INFO_SUCCESS = 'FETCH_SITE_CARD_VALUE_INFO_SUCCESS';
export const FETCH_SITE_CARD_VALUE_INFO_FAILURE = 'FETCH_SITE_CARD_VALUE_INFO_FAILURE';

export const FETCH_SITE_CARD_NEARBY_REQUEST = 'FETCH_SITE_CARD_NEARBY_REQUEST';
export const FETCH_SITE_CARD_NEARBY_SUCCESS = 'FETCH_SITE_CARD_NEARBY_SUCCESS';
export const FETCH_SITE_CARD_NEARBY_FAILURE = 'FETCH_SITE_CARD_NEARBY_FAILURE';

export const FETCH_SITE_CARD_TITLE_DEEDS_REQUEST = 'FETCH_SITE_CARD_TITLE_DEEDS_REQUEST';
export const FETCH_SITE_CARD_TITLE_DEEDS_SUCCESS = 'FETCH_SITE_CARD_TITLE_DEEDS_SUCCESS';
export const FETCH_SITE_CARD_TITLE_DEEDS_FAILURE = 'FETCH_SITE_CARD_TITLE_DEEDS_FAILURE';

export const CREATE_SITE_CARD_PLANNING_ALERT_REQUEST = 'CREATE_SITE_CARD_PLANNING_ALERT_REQUEST';
export const CREATE_SITE_CARD_PLANNING_ALERT_SUCCESS = 'CREATE_SITE_CARD_PLANNING_ALERT_SUCCESS';
export const CREATE_SITE_CARD_PLANNING_ALERT_FAILURE = 'CREATE_SITE_CARD_PLANNING_ALERT_FAILURE';